const pluralize = (count, noun, suffix = 's') => {
    if (count === 1) {
        return noun;
    }
    switch (suffix) {
        case 's':
        case 'es':
            return `${noun}${suffix}`;
        case 'ies':
            return `${noun.slice(0, noun.length - 1)}${suffix}`;
        default:
            return noun;
    }
};
export { pluralize };
